module.exports = __webpack_public_path__ + "static/media/recomm_lev.eb04ff1c.png";